import { render } from "./Order.vue?vue&type=template&id=eb9ac222"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=eb9ac222&lang=css"
script.render = render

export default script